document.addEventListener('DOMContentLoaded', () => {
    // Get mobile navigation hamburger + close button
   const mobileHamburger = document.querySelector('.main-navigation__inner__logo__nav-hamburger');

   // Get nav items
   const navItemsContainer = document.querySelector('.main-navigation__inner__nav-items-container');

     /* Open Login navigation */ 
     mobileHamburger.addEventListener('click', () => {
        mobileHamburger.classList.toggle('close-nav');
        navItemsContainer.classList.toggle('nav-open');
    });
});